/**
 * Scroll-to-bundle: Intercepts CTA button clicks on the product page
 * and smooth-scrolls to the bundle selector instead of adding to cart.
 * Targets: ai-hero-cta buttons, iwt-button buttons (image-with-text sections)
 */
(function () {
  var bundleTarget = document.getElementById('shopify-section-main');
  if (!bundleTarget) return;

  function scrollToBundle(e) {
    e.preventDefault();
    e.stopPropagation();
    bundleTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Match hero CTA buttons and image-with-text buttons by class prefix
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[class*="ai-hero-cta-"], button[class*="iwt-button-"]'
    );
    if (!btn) return;

    // Only intercept if this button is inside a form (ATC form)
    var form = btn.closest('form[action*="/cart/add"]');
    if (form) {
      scrollToBundle(e);
    }
  }, true);

  // Also prevent the form submit event as a safety net
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (
      form.action &&
      form.action.indexOf('/cart/add') !== -1 &&
      form.querySelector(
        'button[class*="ai-hero-cta-"], button[class*="iwt-button-"]'
      )
    ) {
      scrollToBundle(e);
    }
  }, true);
})();
